<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Cadastrar Unidade") }}</h1>

        <b-card class="shadow">
            <template v-slot:default>
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />
                <form @submit.prevent="addItem" ref="addItem">
                    <div class="row">
                        <b-form-group
                            class="mb-2 col-md-12"
                            label-for="nome_tipo_unidade"
                        >
                            <label for="nome_tipo_unidade">
                                <strong
                                    >{{ $t("Tipo da Unidade") }}
                                    <span class="text-danger">*</span>
                                </strong>
                            </label>
                            <v-select
                                label="nome_tipo_unidade"
                                :filterable="true"
                                :options="tiposUnidadesList"
                                @search="onSearch"
                                v-model="item.nome_tipo_unidade"
                                placeholder="Pesquise o Tipo da Unidade. Ex.: CRAS, CREAS, CENTRO POP..."
                            >
                                <template slot="no-options">
                                    Digite o nome do tipo que deseja localizar.
                                    Ex.: CRAS, CREAS, CENTRO POP...
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.nome_tipo_unidade }}
                                    </div>
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    <div class="selected d-center">
                                        {{ option.nome_tipo_unidade }}
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>
                        <form-select
                            v-if="
                                item.nome_tipo_unidade &&
                                item.nome_tipo_unidade.nome_tipo_unidade ==
                                    'UA - UNIDADE ACOLHIMENTO'
                            "
                            v-model="item.subtipo_id"
                            :itens="subtiposAcolhimento"
                            label="Subtipos"
                        />
                        <form-input
                            v-model="item.nome"
                            grid="12"
                            label="Nome"
                            :required="true"
                        />
                    </div>
                    <div
                        class="row"
                        v-if="
                            item.nome_tipo_unidade &&
                            item.nome_tipo_unidade.nome_tipo_unidade ==
                                'UE - UNIDADE EXTERNA'
                        "
                    >
                        <div class="col-md-12">
                            <b-link
                                href="#"
                                @click.prevent="showUnidadeExterna = false"
                                v-if="showUnidadeExterna"
                                >Mostrar campos extras</b-link
                            >
                            <b-link
                                v-else
                                href="#"
                                @click.prevent="showUnidadeExterna = true"
                                >Esconder campos extras</b-link
                            >
                        </div>
                    </div>
                    <div class="row" v-if="!showUnidadeExterna">
                        <form-input
                            v-model="item.email"
                            grid="6"
                            label="E-mail"
                            :required="true"
                        />

                        <form-input
                            v-model="item.telefone"
                            grid="6"
                            label="Telefone(s)"
                            :required="true"
                            placeholder="Telefone(s) da Unidade"
                        />

                        <form-input
                            v-model="item.razao_social"
                            grid="6"
                            label="Razão Social"
                        />

                        <form-input
                            v-model="item.cnpj"
                            grid="6"
                            label="CNPJ"
                            v-mask="'##.###.###/####-##'"
                            placeholder="00.000.000/0000-00"
                        />

                        <form-input
                            v-model="item.cadsuas"
                            grid="4"
                            label="Número CADSUAS"
                            ajuda="O CadSUAS é o sistema de Cadastro do SUAS (Sistema Único de Assistência Social), instituído pela Portaria nº 430, de 3 de dezembro de 2008 e  nele são registradas todas as informações cadastrais de prefeituras, unidades gestoras, fundos, conselhos municipais, rede socioassistencial e trabalhadores do SUAS."
                        />

                        <form-input
                            v-model="item.cneas"
                            grid="4"
                            label="Número CNEAS"
                            ajuda="Como saber o número do Cneas?
A Consulta do CNEAS pode ser acessada pela área de Assistência Social do site do MDS (www.mds.gov.br/assuntos/assistencia-social) ou diretamente no endereço (http://aplicacoes.mds.gov.br/cneas/publico/xhtml/consultapublica/pesquisar.jsf)."
                        />

                        <form-input
                            v-model="item.cmas"
                            grid="4"
                            label="Número CMAS"
                            ajuda="O Conselho Municipal de Assistência Social - CMAS é o órgão que reúne representantes do governo e da sociedade civil para discutir, estabelecer normas e fiscalizar a prestação de serviços sociais públicos e privados no Município."
                        />

                        <form-input
                            v-model="item.expediente"
                            grid="6"
                            label="Expediente"
                            v-mask="'##:## às ##:##'"
                            placeholder="Exemplo: 07:00 às 16:00"
                        />

                        <form-input v-model="item.site" grid="6" label="Site" />
                    </div>
                    
                    <form-endereco
                        :item="item.endereco"
                        v-if="!showUnidadeExterna"
                    />

                    <div class="row" v-if="!showUnidadeExterna">
                        <form-textarea-editor
                            v-model="item.observacoes"
                            label="Observação"
                        />
                    </div>

                    <div class="float-right mt-3">
                        <router-link
                            v-b-tooltip.hover
                            title="Voltar para Unidades"
                            class="btn btn-default"
                            to="/dashboard/unidades"
                        >
                            <i class="mdi mdi-arrow-left"></i>
                        </router-link>
                        <button
                            class="btn btn-success btn-submit"
                            data-style="zoom-in"
                            type="submit"
                        >
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </form>
            </template>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Add",
    data() {
        return {
            loading: false,
            tiposUnidadesList: [],
            subtiposAcolhimento: [],
            localidades: [],
            localidade: {},
            logradouros: [],
            logradouro: {},
            item: {
                nome_tipo_unidade: null,
                numero_endereco: "",
                complemento_endereco: "",
                referencia_endereco: "",
                localidade_id: "",
                logradouro_id: "",
                endereco: {
                    numero_endereco: null,
                    complemento_endereco: null,
                    referencia_endereco: null,
                    abrigo: false,
                    localidade_id: null,
                    logradouro_id: null,
                    estado_id: null,
                    cidade_id: null,
                    situacao_rua: false,
                    cidade: null,
                    estado: null,
                    logradouros: null,
                    localidade: null,
                    cep: null,
                },
            },
            localidade_bairro: "",
            logradouro: "",
            loadingLocalidade: false,
            loadingLogradouros: false,
            showUnidadeExterna: false,
        };
    },
    mounted() {
        this.getSubtipos();
    },
    watch: {
        "item.nome_tipo_unidade": function (val) {
            val.nome_tipo_unidade == "UE - UNIDADE EXTERNA"
                ? (this.showUnidadeExterna = true)
                : (this.showUnidadeExterna = false);
        },
    },
    methods: {
        getSubtipos() {
            axios.get("api/dashboard/unidades/getsubtipos").then((response) => {
                this.subtiposAcolhimento = response.data;
            });
        },
        addItem() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios.post("api/dashboard/admin/unidades", this.item).then((response) => {
                ladda.stop();
                this.$snack.success({
                    button: false,
                    text: response.data.data.message,
                });
                this.$router.push("/dashboard/unidades");
            });
        },
        onSearch(search, loading) {
            loading(true);
            this.search(loading, search, this);
        },
        search(loading, search, vm) {
            axios
                .get(`api/dashboard/tipounidade/pesquisar?q=${escape(search)}`)
                .then((response) => {
                    this.tiposUnidadesList = response.data;
                    loading(false);
                });
        },

        setSelected(value) {
            this.loadingLogradouros = true;
            if (value) {
                axios
                    .get(
                        `api/dashboard/enderecos/pesquisar_logradouro?logradouro=${escape(
                            value
                        )}`
                    )
                    .then((response) => {
                        this.logradouros = response.data;
                    })
                    .finally(() => {
                        this.loadingLogradouros = false;
                    });
            }
        },
    },
};
</script>
